import(/* webpackMode: "eager", webpackExports: ["NavigationLab"] */ "/home/runner/work/udata-site/udata-site/components/Navigation/NavigationLab.tsx");
